export const PROPERTY_DETAIL_PAGE_TRACKING_SOURCE = 'property-detail-page';
